<template>
  <v-dialog v-model="dialog" persistent width="750">
    <v-card>
      <!-- Cabecera del formulario -->
      <!-- <v-card-title class="cabecera2">
        <v-flex xs9> <v-icon>send</v-icon>Aprobar reprogramación</v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title> -->
      <v-toolbar color="#7e5ec2">
        <span class="material-symbols-outlined"> </span>
        <p class="tituloCard">Aprobar reprogramación</p>
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <h4 class="texto">
                  <strong class="titulo">Número:</strong>
                  {{ this.form.numero }}
                </h4>
              </v-flex>
              <v-flex xs12>
                <h4 class="texto">
                  <strong class="titulo">Nombre:</strong>
                  {{ this.form.nombres }}
                </h4>
              </v-flex>

              <v-flex xs12>
                <h4 class="subtitulo2">
                  <strong>{{ subtitulo_detalle }}</strong>
                </h4>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <v-data-table
                  :items="lista_papeleta"
                  class="elevation-1"
                  hide-actions
                  :headers="headers"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">{{ props.item.fecha_desde }}</td>
                    <td class="text-xs-center">{{ props.item.fecha_hasta }}</td>

                    <td class="text-xs-center">{{ props.item.dias }}</td>
                    <td class="text-xs-center">{{ props.item.estado }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <v-flex
              xs12
              v-if="
                lista_reprogramaciones.length > 0 &&
                (form.tipo == 'FR' || form.tipo == 'R')
              "
            >
              <h4><strong>Detalle de reprogramación de vacación</strong></h4>
            </v-flex>
            <v-layout>
              <v-flex xs12>
                <v-data-table
                  v-if="
                    lista_reprogramaciones.length > 0 &&
                    (form.tipo == 'FR' || form.tipo == 'R')
                  "
                  :items="lista_reprogramaciones"
                  class="elevation-1"
                  hide-actions
                  :headers="headers_reprogramaciones"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">{{ props.item.secuencia }}</td>
                    <td class="text-xs-center">{{ props.item.fecha_desde }}</td>
                    <td class="text-xs-center">{{ props.item.fecha_hasta }}</td>

                    <td class="text-xs-center">{{ props.item.total_dias }}</td>
                    <td class="text-xs-center">{{ props.item.estado }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <v-flex xs12>
              <h4 class="subtitulo2">
                <strong>{{ subtitulo_seguimiento }}</strong>
              </h4>
            </v-flex>
            <v-layout>
              <v-flex xs12>
                <v-data-table
                  :items="lista_detalle"
                  class="elevation-1"
                  hide-actions
                  :headers="headers2"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">
                      {{ props.item.fecha_registro }}
                    </td>
                    <td class="text-xs-center">{{ props.item.estado }}</td>
                    <td class="text-xs-center">{{ props.item.usuario }}</td>
                    <td class="text-xs-center">{{ props.item.jefe }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="rgba(14, 187, 178, 0.35)"
            @click.prevent="solicitarUsoVacacion()"
            ><v-icon>send</v-icon>
            Enviar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      user: this.$storage.get("user"),
      form: {
        funcionario: {
          nombre: "",
        },
      },
      valid: false,
      loading: false,
      lista_papeleta: [],
      lista_detalle: [],
      lista_reprogramaciones: [],
      subtitulo_detalle: "Detalle de vacación programada",
      subtitulo_seguimiento: "Seguimiento de vacación programada",
      headers: [
        { text: "Fecha salida", sortable: false, align: "center" },
        { text: "Fecha fin", sortable: false, align: "center" },
        { text: "Dias", sortable: false, align: "center" },
        { text: "Estado", sortable: false, align: "center" },
      ],
      headers2: [
        { text: "Fecha registro", sortable: false, align: "center" },
        { text: "Estado", sortable: false, align: "center" },
        { text: "Usuario", sortable: false, align: "center" },
        { text: "Solicitud enviada a:", sortable: false, align: "center" },
      ],
      headers3: [
        { text: "Nro", sortable: false, align: "center" },
        { text: "Fecha salida", sortable: false, align: "center" },
        { text: "Fecha fin", sortable: false, align: "center" },
        { text: "Dias", sortable: false, align: "center" },
        { text: "Estado", sortable: false, align: "center" },
      ],
      headers_reprogramaciones: [
        { text: "Nro", sortable: false, align: "center" },
        { text: "Fecha desde", sortable: false, align: "center" },
        { text: "Fecha hasta", sortable: false, align: "center" },
        { text: "Dias", sortable: false, align: "center" },
        { text: "Estado", sortable: false, align: "center" },
      ],
    };
  },
  async mounted() {
    this.$bus.$on("openDialogAprobarReprogramacion", async (item) => {
      this.form = item;
      if (this.form.tipo == "FR") {
        await this.cargarReprogramaciones();
        this.titulo = "Ver reprogramación de vacaciones";
        this.subtitulo_detalle =
          "Detalle de vacación programada a ser reprogramada";
        this.subtitulo_seguimiento =
          "Seguimiento de reprogramación de vacación";
      }
      if (this.form.tipo == "R") {
        await this.cargarReprogramaciones();
        this.titulo = "Ver reprogramación de vacación";
        this.subtitulo_detalle = "Detalle de vacación reprogramada";
        this.subtitulo_seguimiento = "Seguimiento de vacación reprogramada";
      }
      this.form.id = parseInt(this.form.id);
      this.cargarTablaPapeleta();
      this.dialog = true;

      await this.cargarSeguimiento();
    });
  },

  methods: {
    close() {
      this.form = {
        funcionario: {
          nombre: "",
        },
      };
      this.lista_papeleta = [];
      this.loading = false;
      this.valid = false;
      this.$bus.$emit("closeDialogSolicitarUsoVacacionFuncionario");
      this.dialog = false;
    },
    cargarTablaPapeleta() {
      this.lista_papeleta.push(this.form);
    },
    async cargarReprogramaciones() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
                query{
                    runQuery(consulta:"select * from vacaciones.v_vacaciones_reprogramadas vsvp where vsvp.id_padre =${parseInt(
                      this.form.id_vacacion
                    )}"){
                        respuesta
                    }
                    }
                `,
        });
        console.log("+++", respuesta.runQuery.respuesta);
        if (respuesta.runQuery.respuesta.length > 0) {
          respuesta = respuesta.runQuery.respuesta;
          this.lista_reprogramaciones = respuesta;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async cargarSeguimiento() {
      try {
        let respuesta;
        let id_vaca_programada = parseInt(this.form.id_vacacion);
        if (
          this.lista_reprogramaciones.length &&
          (this.form.tipo == "FR" || this.form.tipo == "R")
        ) {
          //SEGUIMIENTO DE LOS HIJOS
          id_vaca_programada = parseInt(
            this.lista_reprogramaciones[0].id_vacacion_programada
          );
        }
        respuesta = await this.$service.graphql({
          query: `
              query{
                  runQuery(consulta:"select * from vacaciones.v_seguimiento_vaca_progra vsvp  where vsvp.id_vaca_progra =${id_vaca_programada}"){
                      respuesta
                  }
                  }
              `,
        });
        respuesta = respuesta.runQuery.respuesta;
        this.lista_detalle = respuesta;
      } catch (error) {
        console.log(error);
      }
    },
    async solicitarUsoVacacion() {
      let respuesta;
      let resps = [];
      let correcto = true;
      let user = this.$storage.get("user");
      this.loading = true;
      try {
        respuesta = await this.$service.graphql({
          query: `
			query{
				runQuery(consulta:"select vacaciones.fn_aprueba_vacacion_reprogramada_jefe_en_grupo(${parseInt(
          this.form.id_vacacion
        )},70,${user.id_persona},${user.id})"){
					respuesta
				}
			}
		`,
        });

        respuesta =
          respuesta.runQuery.respuesta[0]
            .fn_aprueba_vacacion_reprogramada_jefe_en_grupo;
        resps = respuesta.split("|");
        correcto = resps[0];

        if (correcto === "1") {
          this.$confirm("La reprogramación fué aprobada", () => {
            this.loading = false;
            this.close();
          });
        } else {
          this.$confirm(resps[1], () => {
            this.loading = false;
          });
        }
      } catch (error) {
        console.log(error);
        this.close();
      }
    },
  },
};
</script>

<style>
.titulo {
  font-size: 1.07em;
  color: rgb(20, 7, 84);
  font-weight: bold;
}
.texto {
  font-size: 1.07em;
  color: rgb(20, 7, 84);
}
.subtitulo2 {
  font-size: 1.35em;
  color: rgb(20, 7, 84);
  font-weight: bolder;
}
.cabecera2 {
  background-color: rgba(20, 7, 84, 0.35);
  font-size: 1.5em;
  color: rgba(20, 7, 84);
  font-weight: bolder;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_uso/dialogs/AprobarReprogramacionVacacion.vue